/**
 * Created by sswaminathan on 2/8/22
 * File: SplashFooter
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

// import statement lib, local then scss or css

/**
 *   TODO: Brief what is this component/class do
 */
import { PANWLogo } from '../../../common/assets/images'
import './splashFooter.scss'
import { DISCLAIMER } from '../constants/SubscriptionConstant'

export const footerLabel = [
  {
    0: [
      {
        label: 'Company',
        href: 'https://www.paloaltonetworks.com/company'
      },
      {
        label: 'Careers',
        href: 'https://www.paloaltonetworks.com/company/careers'
      }
    ]
  },
  {
    1: [
      {
        label: 'Privacy Policy',
        href: 'https://www.paloaltonetworks.com/legal-notices/privacy'
      },
      {
        label: 'TermsAndConditions of Use',
        href: 'https://www.paloaltonetworks.com/legal-notices/terms-of-use'
      }
    ]
  },
  {
    2: [
      {
        label: 'Manage Subscription',
        href: 'https://www.paloaltonetworks.com/company/subscriptions'
      }
    ]
  },
  {
    3: [
      {
        label: 'LinkedIn',
        href: 'https://www.linkedin.com/company/palo-alto-networks'
      },
      {
        label: 'Facebook',
        href: 'https://www.facebook.com/PaloAltoNetworks/'
      },
      {
        label: 'Twitter',
        href: 'https://twitter.com/PaloAltoNtwks'
      }
    ]
  }

]
const eachCol = (arr, idx) => {
  return <div key={idx} className={'tw-flex tw-flex-1 tw-flex-col tw-mt-1 footer-col'}>
    {
      arr.map((each, idx) => {
        const { label, href } = each
        return <a key={idx} href={href} rel='noopener noreferrer' target='_blank'>{label}</a>
      })
    }
  </div>

}

const SplashFooter = ({ showLogo, showSignature }) => {
  return (
    <div className='setup-footer tw-flex tw-flex-1 tw-flex-col tw-items-center' >
      <div className='tw-flex tw-flex-row'>
        {
          footerLabel.map((each, idx) => eachCol(each[idx], idx))
        }
      </div>
      {showLogo ? <div className='tw-mt-3'>
        <img
          className='panw-logo tw-ml-8' alt={'logo'}
          src={PANWLogo} />  </div> : null}
      {
        showSignature ? <div className={'footer-col tw-mt-2'}>© {new Date().getFullYear()} {DISCLAIMER}</div> : null
      }
    </div>
  )
}

SplashFooter.propTypes = {}
export default SplashFooter
